export default "__VITE_ASSET__AuGsFCh___"